module.exports = __webpack_public_path__ + "img/public-bank-img.32babaf3.png";